import { Card } from '@components/common/Card';
import { Container } from '@components/common/Container';
import { Icon } from '@components/Icon';

import { photos } from '@assets/photos';

const INTRO =
  'Classes are offered only on Thursdays at varying times between 9:00 AM - 1:30 PM. Families can sign up for one or multiple classes, depending on needs and availability.';

const FEATURE_ITEMS = [
  'Fall and Spring semesters (12 weeks each)',
  'Preschool through Adult Bible Study',
  'Academic and enrichment classes',
  'Field trips, meet-ups, and Spring Field Day events',
  'Bible studies and training for parents',
];

const SUPERVISION_TITLE = 'Parent Supervision';
const SUPERVISION_TEXT =
  "A parent/guardian is required to remain on the Church campus for students ages 3 through 14 years old. High School students (15 years and up) can be dropped off for their classes. They will not be supervised between classes or during lunch, but will be under disciplinary actions of the director/tutors while on campus. Parents may choose to stay on-site for additional supervision.";

export function HowItWorksSection() {
  return (
    <section className="bhg-landing-section bhg-landing-section--alt">
      <Container size="lg">
        <div className="bhg-landing-how-it-works">
          <div className="bhg-landing-how-it-works__content">
            <h2 id="how-it-works-heading" className="bhg-landing-section__title">How It Works</h2>
            <h3 className="bhg-landing-how-it-works__subtitle">
              Two 12-Week Semesters
            </h3>
            <p className="bhg-landing-how-it-works__text">{INTRO}</p>
            <ul className="bhg-landing-feature-list">
              {FEATURE_ITEMS.map((item, i) => (
                <li key={i} className="bhg-landing-feature-list__item">
                  <Icon
                    type="checkmark"
                    style="filled"
                    colorVariant="green"
                    size="sm"
                    aria-label=""
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="bhg-landing-how-it-works__image">
            <img
              src={photos.momsAndToddlers.src}
              srcSet={photos.momsAndToddlers.srcSet}
              sizes={photos.momsAndToddlers.contentSizes}
              alt="Moms and toddlers at BHG"
              loading="lazy"
              decoding="async"
              width={400}
              height={267}
            />
          </div>
        </div>

        <Card elevation={2} className="bhg-landing-supervision-card">
          <div className="bhg-landing-supervision-card__content">
            <Icon
              type="exclamation-circle"
              style="filled"
              colorVariant="blue"
              size="lg"
              aria-label=""
            />
            <div>
              <h4 className="bhg-landing-supervision-card__title">
                {SUPERVISION_TITLE}
              </h4>
              <p className="bhg-landing-supervision-card__text">
                {SUPERVISION_TEXT}
              </p>
            </div>
          </div>
        </Card>
      </Container>
    </section>
  );
}
